


























































import { computed, defineComponent, ref } from "@vue/composition-api";
import { countryList } from "@/lib/countryList";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { FormValues } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BasePage from "@/components/BasePage";
import FormatMoney from "@/components/FormatMoney";
import BillingDetailsForm from "../BillingDetailsForm";
import CardDetailsForm from "../CardDetailsForm";
import PaymentSystemLogo from "../PaymentSystemLogo";

export default defineComponent({
  name: "CardEditView",
  components: {
    BaseCheckbox,
    CardDetailsForm,
    BillingDetailsForm,
    PaymentSystemLogo,
    BasePage,
    BaseIcon,
    BaseButton,
    FormatMoney,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    paymentSystemLogoSrc: {
      type: String,
      default: "/img/cards/netbilling/systems.png",
    },
    isSubscription: {
      type: Boolean,
      default: false,
    },
    price: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const formValidators = ref<(() => {})[]>([]);
    const cardValid = ref(false);
    const billingValid = ref(false);
    const cardDetailsValues = ref<FormValues>({});
    const tcAgree = ref(false);
    const saveCard = ref(false);
    const billingDetailsValues = ref<FormValues>({
      country: countryList[0].code,
    });
    const companyName = computed(() => config.companyName);
    const companyAddress = computed(() => config.companyAddress);
    const buttonText = computed(() => {
      const text = props.isSubscription ? $t("Subscribe") : $t("Purchase");
      return props.price ? $t("{0} for {1}", [text, props.price]) : text;
    });
    const allowSubscribe = computed(() => (props.isSubscription ? saveCard.value : true));
    const canSubmitForm = computed(
      () => cardValid.value && billingValid.value && tcAgree.value && allowSubscribe.value
    );
    const setFormValidators = (validator: () => {}) => {
      formValidators.value.push(validator);
    };

    const onSubmit = () => {
      formValidators.value.forEach(c => c());
      if (!canSubmitForm.value) return;
      emit("submit", {
        cardDetails: cardDetailsValues.value,
        billingDetails: billingDetailsValues.value,
        saveCard: saveCard.value,
      });
    };

    return {
      tcAgree,
      saveCard,
      cardValid,
      buttonText,
      companyName,
      billingValid,
      canSubmitForm,
      companyAddress,
      cardDetailsValues,
      billingDetailsValues,
      onSubmit,
      setFormValidators,
    };
  },
});
